export default "__VITE_ASSET__1bb5f490__"